import { useTranslation } from 'react-i18next'

export default ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const label = t('Flag of United Kingdom.', { context: 'alt text for image of the UK flag' })

  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={label}
      className={className}
    >
      <rect x="0.717854" y="3.42857" width="24" height="17.1429" rx="2" fill="white" />
      <mask
        id="mask0_1_2378"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="3"
        width="25"
        height="18"
      >
        <rect x="0.717854" y="3.42857" width="24" height="17.1429" rx="2" fill="white" />
      </mask>
      <g mask="url(#mask0_1_2378)">
        <rect x="0.717854" y="3.42857" width="24" height="17.1429" fill="#0A17A7" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-0.381402 1.78592L9.86071 8.69431V2.28573H15.575V8.69432L25.8171 1.78593L27.0953 3.68087L18.9975 9.14287H24.7179V14.8572H18.9975L27.0953 20.3192L25.8171 22.2141L15.575 15.3057V21.7143H9.86071V15.3057L-0.381398 22.2141L-1.65955 20.3192L6.43823 14.8572H0.717857V9.14287H6.4382L-1.65956 3.68086L-0.381402 1.78592Z"
          fill="white"
        />
        <path d="M16.719 8.85618L27.575 1.71429" stroke="#DB1F35" strokeWidth="0.666667" strokeLinecap="round" />
        <path d="M17.8717 15.1693L27.6035 21.7289" stroke="#DB1F35" strokeWidth="0.666667" strokeLinecap="round" />
        <path d="M7.57973 8.83755L-2.57143 1.99631" stroke="#DB1F35" strokeWidth="0.666667" strokeLinecap="round" />
        <path d="M8.68073 15.0899L-2.57143 22.5518" stroke="#DB1F35" strokeWidth="0.666667" strokeLinecap="round" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.717854 13.7143H11.0036V20.5714H14.4321V13.7143H24.7179V10.2857H14.4321V3.42857H11.0036V10.2857H0.717854V13.7143Z"
          fill="#E6273E"
        />
      </g>
    </svg>
  )
}
